import styled, {css} from "styled-components"

import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {ButtonRouterLink} from "@irati/ui/src/Link"

export const GridWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  background: ${greys.lightest}

  ${minWidthMedia.tablet`
    margin-bottom: ${padding.base};
    padding: ${padding.small} ${padding.small} ${padding.tiny};
    background: ${greys.white};
    border-radius: 3px;
    box-shadow: ${({theme}) => theme.shadows.low};
  `}

  ${minWidthMedia.desktop`
    padding: ${padding.small} ${padding.medium} ${padding.small} ${padding.small};
    flex-direction: row;
    align-items: center;
  `}
`

export const ImageTextWrapper = styled.div`
  display: flex;
  align-items: center;
`

const ButtonStyles = css`
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  width: 100%;
  margin: ${padding.small} 0;

  ${minWidthMedia.tablet`
    margin: ${padding.tiny} 0;
  `}

  ${minWidthMedia.desktop`
    width: 30%;
  `}
`

export const StyledButton = styled(Button)`
  ${ButtonStyles}
`

export const StyledRouterLink = styled(ButtonRouterLink)`
  ${ButtonStyles}
`

export const Image = styled.img`
  width: 90px;
  height: 90px;
  padding-right: ${padding.small};
`

export const InverseGeoPin = styled(Icon)`
  stroke: ${greys.black};
  fill: none;
`
